var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { IsEnum, IsIn, IsOptional, IsString } from "class-validator";
import { INGEST_TYPE_VALUES } from "./healthcareorganization.dtos";
export var EpicEnvironment;
(function (EpicEnvironment) {
    EpicEnvironment["PRODUCTION"] = "PRODUCTION";
    EpicEnvironment["NON_PRODUCTION"] = "NON_PRODUCTION";
})(EpicEnvironment || (EpicEnvironment = {}));
export class AgentConfigurationDto {
    constructor(fields) {
        Object.assign(this, fields);
    }
}
__decorate([
    IsString()
], AgentConfigurationDto.prototype, "ingestType", void 0);
__decorate([
    IsString(),
    IsOptional()
], AgentConfigurationDto.prototype, "fhirEndpoint", void 0);
__decorate([
    IsEnum(EpicEnvironment),
    IsOptional()
], AgentConfigurationDto.prototype, "epicEnvironment", void 0);
__decorate([
    IsString({ each: true }),
    IsOptional()
], AgentConfigurationDto.prototype, "idStartsWith", void 0);
__decorate([
    IsString()
], AgentConfigurationDto.prototype, "organizationId", void 0);
export class UpdateAgentConfigurationInput {
    constructor(fields) {
        Object.assign(this, fields);
    }
}
__decorate([
    IsString(),
    IsIn(INGEST_TYPE_VALUES)
], UpdateAgentConfigurationInput.prototype, "ingestType", void 0);
__decorate([
    IsString(),
    IsOptional()
], UpdateAgentConfigurationInput.prototype, "fhirEndpoint", void 0);
__decorate([
    IsEnum(EpicEnvironment),
    IsOptional()
], UpdateAgentConfigurationInput.prototype, "epicEnvironment", void 0);
__decorate([
    IsString({ each: true }),
    IsOptional()
], UpdateAgentConfigurationInput.prototype, "idStartsWith", void 0);
__decorate([
    IsString()
], UpdateAgentConfigurationInput.prototype, "organizationId", void 0);
